import React from 'react';
import { Grid, KeyValue } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from '../../../components/form-items/FormHeader';

interface ExamLevelDetailsProps {
  examYear: any;
  examLevel: string;
  examSeries: string;
  indexNo: any;
  formHeader?: string;
}

const ExamLevelDetails = ({
  examYear,
  examLevel,
  examSeries,
  indexNo,
  formHeader,
}: ExamLevelDetailsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <FormHeader title={formHeader || t('components->>SubjectSelectionTable.Select Subject(s)')} />

      <Grid md={5} sm={12} xs={12}>
        <KeyValue
          id="examYear"
          keyText={t('components->>PersonalDetails.Exam Year')}
          valueText={examYear}
        />
      </Grid>

      <Grid container direction="row">
        <Grid md={5} sm={12} xs={12}>
          <KeyValue
            id="school"
            keyText={t('components->>PersonalDetails.Exam Level')}
            valueText={examLevel}
          />
        </Grid>
        <Grid md={5} sm={12} xs={12}>
          <KeyValue
            id="indexNo"
            keyText={t('components->>PersonalDetails.Exam Series')}
            valueText={examSeries}
          />
        </Grid>
      </Grid>

      <Grid container direction="row">
        <Grid md={5} sm={12} xs={12}>
          <KeyValue
            id="indexNo"
            keyText={t('components->>PersonalDetails.Index No.')}
            valueText={indexNo ? indexNo.toString() : '-'}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ExamLevelDetails;
